import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IProductoRequisito } from '../../interfaces/response/IProductoRequisito';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductosRequisitoService {

  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiProducto}`;
  url: string;

  /**
   * Set the url property
   */
  constructor(
    private http: HttpClient,
  ) {
    this.url = this.baseUrl + this.apiUrl;
  }

  /** 
   * Get the producto requisitos related to and idProducto and idOperativa
   * @param idProducto The idProducto to filter
   * @param idOperativa The idOperativa to filter
   * @returns An observable with the array of productoRequisitos found
   */
  getProductosRequisito(idProducto: number, idOperativa: number) { 
    return this.http.get<IHttpResponse<IProductoRequisito[]>>(`${this.url}/GetProductsRequeriments/${idProducto}/requeriment/${idOperativa}`);
  }
  
  
  getBerriaSerialNumbers(oid: string) { 
    return this.http.get<any>(`${this.url}/GetSerialNumbers/${oid}`).pipe(
      map(response => {
        response.data.sort((a, b) => a.objetos[0].serialNumber - b.objetos[0].serialNumber)
        return response
      })
    )
  }
}
